export default "__VITE_ASSET__DafpwcVp__"